import React from 'react';

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import PropTypes from 'prop-types';

import { FeeRecordingType } from 'constants/feeTypes';
import {
  accountingFormatOptions,
  currencyOptions as defaultCurrencyOptions,
  LESection,
} from 'constants/loanApplication';
import { LoanFeePayerEnum } from 'constants/loanFee';
import { getTotalAmountFee } from 'utils/loanFees';
import { formatNumberToCurrencyString } from 'utils/number';

import { recordingFeesHeadingLabels } from './RecordingFeesData.constants';
import {
  tableBodyStyles,
  tableContainerStyles,
  tableHeadStyles,
  titleTypographyStyles,
} from './RecordingFeesData.styles';

const defaultArray = [];

const currencyOptions = {
  ...defaultCurrencyOptions,
  ...accountingFormatOptions,
  minimumFractionDigits: 2,
};

const RecordingFeesData = ({ data = defaultArray }) => {
  return (
    <>
      <Typography sx={titleTypographyStyles} variant="regular14">
        Recording Fees
      </Typography>

      <TableContainer className="table-container" sx={tableContainerStyles}>
        <Table className="table">
          <TableHead className="table-head" sx={tableHeadStyles}>
            <TableRow className="table-row">
              {recordingFeesHeadingLabels.map(({ label, align }) => (
                <TableCell align={align} className="table-cell" key={label}>
                  {label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody className="table-body" sx={tableBodyStyles}>
            {data.length ? (
              data.map((fee, ind) => {
                const { recordingType, feeTypeId, feeName } = fee;

                const amount = getTotalAmountFee(fee);

                return (
                  <TableRow className="table-row" key={`${ind}-${feeTypeId}`}>
                    <TableCell align="left" className="table-cell">
                      {recordingType}
                    </TableCell>
                    <TableCell align="left" className="table-cell">
                      {feeName}
                    </TableCell>
                    <TableCell align="right" className="table-cell">
                      {formatNumberToCurrencyString(amount ?? 0, currencyOptions)}
                    </TableCell>
                  </TableRow>
                );
              })
            ) : (
              <TableRow className="table-row">
                <TableCell className="table-cell" colspan={3} />
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

RecordingFeesData.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      amount: PropTypes.number,
      beforeClosing: PropTypes.bool,
      feeName: PropTypes.string,
      feePayer: PropTypes.oneOf(Object.values(LoanFeePayerEnum)),
      feeProviderId: PropTypes.string,
      feeProviderName: PropTypes.string,
      feeTypeId: PropTypes.string,
      financedAmount: PropTypes.number,
      leSection: PropTypes.oneOf(Object.values(LESection)),
      recordingType: PropTypes.oneOf([FeeRecordingType.DEED, FeeRecordingType.MORTGAGE]),
    }),
  ),
};

export default RecordingFeesData;
